import { api } from '@/store/api'

import Env from '../../../env/env'

import type {
  PlanHistoryCrudresponse,
  PlanHistoryRequest,
  PlanHistoryResponse,
  TopupProduct,
  CreateCheckoutSessionDto,
  CheckoutSessionResponse,
  CreatePortalSessionDto,
  PortalSessionResponse,
  RetrieveCheckoutSessionRequestDto,
  CreatePricingTableSessionDto,
  PricingProduct,
  PricingTableResponse,
  TopupProductResponse,
} from './Stripe.types'

export const planApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // useLazyPlanHistoryQuery
    planHistory: builder.query<PlanHistoryResponse, PlanHistoryRequest>({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/accounts/recharge-history`,
        method: 'GET',
        params: {
          page: request.page,
          pageSize: request.pageSize,
        },
      }),
      transformResponse: (response: PlanHistoryCrudresponse) => {
        if (response.info && response.info.rechargeHistory.length) {
          const sortedRechargeHistory = response.info.rechargeHistory.sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
          )
          return {
            ...response.info,
            rechargeHistory: sortedRechargeHistory,
          }
        }
        return response.info
      },
    }),

    // useCreateCheckoutSessionMutation
    createCheckoutSession: builder.mutation<
      CheckoutSessionResponse,
      CreateCheckoutSessionDto
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/stripe/public/create-checkout-session`,
        method: 'POST',
        body: request,
      }),
    }),

    // useGetPublicPricingTableQuery
    getPublicPricingTable: builder.query<
      PricingTableResponse,
      { ip?: string; productType?: string } | void
    >({
      query: (params) => ({
        url: `${Env.BASE_API_URL}/api/v1/stripe/public/pricing-table`,
        method: 'GET',
        params: params || undefined,
      }),
    }),

    // useGetTopupProductsQuery
    getTopupProducts: builder.query<
      TopupProductResponse,
      { ip?: string } | void
    >({
      query: (params) => ({
        url: `${Env.BASE_API_URL}/api/v1/stripe/topup-product`,
        method: 'GET',
        params: params || undefined,
      }),
    }),

    // useCreatePortalSessionMutation
    createPortalSession: builder.mutation<
      PortalSessionResponse,
      CreatePortalSessionDto
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/stripe/portal-sessions`,
        method: 'POST',
        body: {
          ...request,
        },
      }),
    }),
  }),
})

export const {
  useLazyPlanHistoryQuery,
  useCreateCheckoutSessionMutation,
  useCreatePortalSessionMutation,
  useGetPublicPricingTableQuery,
  useLazyGetPublicPricingTableQuery,
  useGetTopupProductsQuery,
} = planApi
